import { Link } from 'react-router-dom';
import {
  Button,
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@zafroi/ui-kit';
import { BookOpen, MessageSquare } from 'lucide-react';

/**
 * Placeholder configure flow for the WhatsApp channel. WhatsApp setup is the
 * next phase — this sheet exists so the row has a working CTA today and the
 * tenant has a place to read the "what to prepare" pointer.
 */
export interface WhatsAppChannelSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function WhatsAppChannelSheet({
  open,
  onOpenChange,
}: WhatsAppChannelSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full max-w-lg sm:max-w-xl overflow-y-auto"
      >
        <SheetHeader className="pr-12">
          <SheetTitle className="flex items-center gap-2">
            <MessageSquare className="h-4 w-4 text-muted-foreground" />
            WhatsApp Business
          </SheetTitle>
          <SheetDescription>
            Two-way WhatsApp engagement, routed into Engage's unified timeline.
          </SheetDescription>
        </SheetHeader>

        <div className="space-y-4 px-5 py-5 text-xs leading-relaxed text-muted-foreground">
          <p>
            WhatsApp setup is coming next — we'll connect via the Meta Business
            API. While we finish that work, you can start preparing:
          </p>
          <ul className="list-inside list-disc space-y-1.5">
            <li>A verified Meta Business Manager account.</li>
            <li>
              A phone number you can dedicate to WhatsApp Business (it can't be
              already in use on a personal WhatsApp account).
            </li>
            <li>Your business display name and a square profile picture.</li>
          </ul>
          <p>
            Once Phase 2 lands, you'll connect with a one-click OAuth step —
            no API keys to paste around.
          </p>
        </div>

        <div className="flex flex-col gap-2 border-t border-border px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
          <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)}>
            Close
          </Button>
          <Button size="sm" asChild>
            <Link to="/chatbot/guide#channels">
              <BookOpen className="h-3.5 w-3.5" />
              See the channels guide
            </Link>
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
